import React from 'react';
import Modal from '@/components/common/Modal';
import AppointmentForm from './AppointmentForm';
import { FaClock, FaStopwatch, FaDollarSign } from 'react-icons/fa';

/**
 * Componente de modal para crear/editar citas
 */
const AppointmentModal = ({
  isOpen,
  selectedDate,
  editingCita,
  formData,
  selectedCliente,
  clienteData,
  isAdmin,
  clientes,
  filteredVehiculos,
  servicios,
  selectedServicios,
  selectedTime,
  horaFin,
  horaFinAjustada,
  tiempoTotal,
  loading,
  handleChange,
  handleServicioSelect,
  handleDeseleccionarTodos,
  handleCancel,
  handleSubmit,
  onClienteVehiculoCreado // Nueva prop
}) => {
  if (!isOpen) return null;

  // Crear un título personalizado con la fecha como subtítulo
  const modalTitle = (
    <div>
      <div>{editingCita ? 'Modificar cita' : 'Programar una cita'}</div>
      <div className="text-sm font-normal text-gray-300 mt-1">
        {selectedDate?.format('dddd, D [de] MMMM [de] YYYY')}
      </div>
    </div>
  );

  // Calcular el precio total
  const calcularPrecioTotal = () => {
    return selectedServicios.reduce((total, servicio) => {
      let precio = 0;
      
      // Si el servicio ya tiene un precio, usarlo directamente
      if (servicio.Precio) {
        precio = Number(servicio.Precio) || 0;
      } else {
        // Si no tiene precio, buscar el servicio en la lista completa
        const servicioCompleto = servicios.find(s => s.id === servicio.id || 
                                                    (servicio.Servicio && 
                                                     (s.id === servicio.Servicio || 
                                                      (Array.isArray(servicio.Servicio) && 
                                                       servicio.Servicio.includes(s.id)))));
        if (servicioCompleto && servicioCompleto.Precio) {
          precio = Number(servicioCompleto.Precio) || 0;
        }
      }
      
      return total + precio;
    }, 0);
  };
  
  const precioTotal = calcularPrecioTotal();

  // Componente para el contenido sticky (ahora dentro del modal)
  const StickyHeader = () => {
    if (selectedServicios.length === 0) return null;
    
    return (
      <div className="lg:hidden sticky-fix top-0 z-20 bg-gray-800 border-b border-gray-700 p-3 -mx-4 -mt-4 mb-4">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center space-x-4">
            {selectedTime && (
              <div className="flex items-center space-x-1 text-gray-300">
                <FaClock className="text-xs" />
                <span className="text-white font-medium">
                  {selectedTime.format('HH:mm')}
                  {horaFin && (
                    <>
                      <span className="text-gray-400"> - {horaFin.format('HH:mm')}</span>
                      {/* Mostrar la fecha cuando la hora de fin fue ajustada a otro día */}
                      {horaFinAjustada && 
                       horaFin.format('YYYY-MM-DD') !== selectedTime.format('YYYY-MM-DD') && (
                        <span className="ml-1 text-yellow-400 text-xs">
                          ({horaFin.format('DD/MM')})
                        </span>
                      )}
                    </>
                  )}
                </span>
              </div>
            )}
            {tiempoTotal > 0 && (
              <div className="bg-blue-600 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center space-x-1">
                <FaStopwatch className="text-xs" />
                <span>{tiempoTotal}min</span>
              </div>
            )}
          </div>
          <div className="flex items-center space-x-1 text-green-400 font-bold">
            <FaDollarSign className="text-xs" />
            <span>{precioTotal.toLocaleString()}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title={modalTitle}
      size="2xl"
    >
      {/* Sticky Header - dentro del contenido del modal */}
      <StickyHeader />
      
      {/* Contenido principal */}
      <AppointmentForm
        formData={formData}
        selectedCliente={selectedCliente}
        clienteData={clienteData}
        isAdmin={isAdmin}
        clientes={clientes}
        filteredVehiculos={filteredVehiculos}
        servicios={servicios}
        selectedServicios={selectedServicios}
        selectedTime={selectedTime}
        horaFin={horaFin}
        horaFinAjustada={horaFinAjustada}
        tiempoTotal={tiempoTotal}
        loading={loading}
        editingCita={editingCita}
        handleChange={handleChange}
        handleServicioSelect={handleServicioSelect}
        handleDeseleccionarTodos={handleDeseleccionarTodos}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        onClienteVehiculoCreado={onClienteVehiculoCreado}
      />
    </Modal>
  );
};

export default AppointmentModal;
